import type { CityConfig } from "../city-template/types";

export const glenviewConfig: CityConfig = {
  city: "Glenview",
  state: "Illinois",
  stateAbbr: "IL",
  slug: "glenview",
  route: "/cities/glenview",
  title: "Emergency Passport Glenview, IL — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Glenview, Illinois — as fast as 24 hours. Fast passport renewal for North Shore business travelers and all Cook County residents. A+ BBB rated registered State Dept. courier serving Glenview, Northbrook, and the North Shore suburbs.",
  h1: "Emergency & Expedited Passport Services in Glenview, IL",
  heroSubtitle: "North Shore business traveler with an international meeting at the Glen and your passport expired? Glenview family heading to Europe for spring break and the kids have no passports? Corporate headquarters employee with a last-minute assignment abroad? We help Glenview residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier serving the North Shore and northern Cook County.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Glenview%20Illinois%20suburban%20downtown%20with%20The%20Glen%20Town%20Center%20featuring%20upscale%20shopping%20and%20dining%20on%20tree%20lined%20boulevards%2C%20the%20Kohl%20Childrens%20Museum%20and%20Gallery%20Park%20with%20manicured%20gardens%20and%20walking%20paths%2C%20classic%20North%20Shore%20suburban%20architecture%20with%20modern%20office%20parks%2C%20commuter%20train%20station%20on%20the%20Metra%20Milwaukee%20District%20North%20Line%2C%20lush%20green%20parks%20and%20golf%20courses%2C%20elegant%20residential%20neighborhoods%20with%20mature%20trees%2C%20sunny%20afternoon%20light%20over%20the%20northern%20Cook%20County%20landscape&width=1800&height=700&seq=glenview-hero-001&orientation=landscape",
  heroImageAlt: "Glenview Illinois The Glen Town Center and North Shore suburban landscape",
  geoPosition: "42.0698;-87.7878",
  geoPlacename: "Glenview, Illinois",
  lastModified: "2026-06-04",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 35 minutes south of Glenview via I-94",
  },
  nearbyCitiesZips: [
    { name: "Glenview", zips: "60025, 60026" },
    { name: "Northbrook", zips: "60062" },
    { name: "Northfield", zips: "60093" },
    { name: "Wilmette", zips: "60091" },
    { name: "Winnetka", zips: "60093" },
    { name: "Glencoe", zips: "60022" },
    { name: "Deerfield", zips: "60015" },
    { name: "Highland Park", zips: "60035" },
    { name: "Morton Grove", zips: "60053" },
    { name: "Niles", zips: "60714" },
    { name: "Skokie", zips: "60076, 60077" },
    { name: "Park Ridge", zips: "60068" },
    { name: "Des Plaines", zips: "60016, 60018" },
    { name: "Mount Prospect", zips: "60056" },
    { name: "Prospect Heights", zips: "60070" },
    { name: "Arlington Heights", zips: "60004, 60005" },
    { name: "Buffalo Grove", zips: "60089" },
    { name: "Wheeling", zips: "60090" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to Chicago Passport Agency — just 35 minutes south via I-94, but you skip the downtown Chicago trip" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting for North Shore and northern Cook County travelers" },
    { icon: "ri-building-line", title: "Corporate Hub", desc: "Serving Glenview's corporate headquarters and business parks with international travel needs" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Ship from UPS Store at The Glen or any FedEx in Glenview — no downtown Chicago trip required" },
  ],
  internalLinks: [
    { name: "Expedited passport in Skokie, IL", route: "/cities/skokie" },
    { name: "Emergency passport help in Evanston, IL", route: "/cities/evanston" },
    { name: "Urgent passport services in Arlington Heights, IL", route: "/cities/arlington-heights" },
    { name: "Illinois passport services overview", route: "/states/illinois" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Glenview, Illinois remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (35 minutes south via I-94) — without you dealing with downtown Chicago traffic and parking. Glenview residents can ship from UPS Store at The Glen Town Center or any FedEx location. For North Shore professionals and families, our courier service saves hours compared to making the drive yourself.",
  fpcOfficeDistance: "Serving Glenview, Northbrook, Northfield, Wilmette, Winnetka, Glencoe, Deerfield, Highland Park, Morton Grove, Niles, Skokie, Park Ridge, Des Plaines, Mount Prospect, Prospect Heights, Arlington Heights, Buffalo Grove, Wheeling, and the entire North Shore region",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Glenview and the entire North Shore region. From The Glen Town Center and corporate office parks to the residential neighborhoods and Metra commuter communities — we serve all of northern Cook County.",
  nearbyCitiesIntro: "We serve Glenview and all nearby communities including Northbrook, Northfield, Wilmette, Winnetka, Glencoe, Deerfield, Highland Park, Morton Grove, Niles, Skokie, Park Ridge, Des Plaines, Mount Prospect, Prospect Heights, Arlington Heights, Buffalo Grove, and Wheeling.",
  howItWorksIntro: "Most Glenview travelers complete everything online and ship documents overnight. No need to drive downtown and deal with Loop traffic and parking — our couriers handle the Chicago Passport Agency trip for you. For North Shore business travelers, this saves hours of productive work time.",
  mistakesIntro: "Glenview is a North Shore corporate hub with numerous international businesses and frequent travelers — yet even seasoned travelers make these passport mistakes. Here are the most common ones in Glenview and northern Cook County.",
  testimonialsIntro: "Glenview travelers — from North Shore corporate executives and frequent international flyers to Glenview families at The Glen and Metra commuters — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Glenview, IL? Here are the most common ones we hear from North Shore travelers and Glenview residents.",
  statePageRoute: "/states/illinois",
  statePageName: "Illinois",
  dmvWebsite: "https://www.ilsos.gov/facilities/facilitylist.html",
  dmvLabel: "Illinois Secretary of State — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Downtown Chicago traffic and parking hassles", "Inconvenient for most North Shore residents"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "No downtown Chicago traffic or parking required", "Perfect for corporate international travel deadlines", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Glenview travelers with immediate departure needs — as fast as 24 hours. Essential for North Shore corporate travelers and last-minute international business trips.",
      bullets: ["24–48 hour turnaround available", "Chicago Passport Agency direct courier", "No downtown Chicago trip — ship from The Glen"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Glenview adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Glenview address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Glenview residents — new citizens, young professionals, and North Shore families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Glenview residents who lost their passport before international business travel or family vacations.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Glenview, Northbrook, and North Shore area families traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Glenview and North Shore residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized passport card for Glenview residents who need land/sea travel to Canada or Mexico — ideal for quick North American business and leisure trips.",
      bullets: ["Land and sea travel to Canada, Mexico, Caribbean", "Wallet-sized convenience", "REAL ID compliant"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Passport replacement for Glenview residents with water-damaged, torn, or otherwise damaged passports that need urgent replacement before travel.",
      bullets: ["DS-11 form with damage explanation", "Photo verification for identity matching", "Emergency replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Second valid passport book for Glenview corporate executives and frequent international business travelers who need a backup while one is with an embassy.",
      bullets: ["Second valid passport book", "Ideal for frequent business travelers", "Keep traveling while visa processes"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Glenview IL", description: "Urgent passport processing for Glenview Illinois travelers and North Shore corporate professionals with immediate departure needs." },
    { name: "Expedited Passport Renewal Glenview IL", description: "Fast passport renewal for Glenview Illinois residents and North Shore travelers." },
    { name: "First-Time Passport Glenview IL", description: "New passport application services for Glenview Illinois residents." },
    { name: "Child Passport Glenview IL", description: "Minor passport services for Glenview Illinois families with children under 16." },
  ],
  testimonials: [
    {
      name: "Robert C.",
      location: "Glenview, IL — Corporate Executive",
      rating: 5,
      text: "International M&A meeting in London — 5 days notice and my passport had 2 months left (under the 6-month rule for UK). Fast Passport Center renewed it in 3 days. Shipped from the UPS at The Glen during my lunch break. No way I was dealing with downtown Chicago traffic and Loop parking. North Shore professionals, this is the only option.",
      service: "Passport Renewal",
    },
    {
      name: "Jennifer M.",
      location: "Glenview, IL",
      rating: 5,
      text: "Spring break trip to France with the kids — booked it then realized all 3 family passports were expired. Fast Passport Center handled everything — 2 renewals and 1 first-time child passport — all done in 5 days. The Glenview post office was quick for the DS-11. Glenview families, way easier than the downtown Chicago hassle.",
      service: "Family Passport Package",
    },
    {
      name: "David L.",
      location: "Northbrook, IL",
      rating: 5,
      text: "Business trip to Singapore — my passport was damaged from a coffee spill in my briefcase. Had 6 days. Fast Passport Center processed a damaged replacement in 3 days. The Glenview-Northbrook area has so many international business travelers — everyone should know about this courier service. Saved me a full afternoon in downtown Chicago.",
      service: "Damaged Passport",
    },
  ],
  facilities: [
    {
      id: "glv-1",
      name: "Glenview Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1400 Patriot Blvd",
      city: "Glenview",
      state: "IL",
      zip: "60026",
      phone: "(847) 998-2339",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Glenview, near The Glen Town Center",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Glenview acceptance facility at The Glen. Convenient to The Glen Town Center, corporate offices, and residential neighborhoods. Modern facility with extended hours. Appointments recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "glv-2",
      name: "Northbrook Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2460 Dundee Rd",
      city: "Northbrook",
      state: "IL",
      zip: "60062",
      phone: "(847) 272-1745",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Northbrook, approximately 3 miles north of Glenview",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Northbrook and northern Glenview residents. Convenient for Northbrook Court area and Dundee Road corridor. Good alternative when Glenview post office is busy.",
      icon: "ri-mail-line",
    },
    {
      id: "glv-3",
      name: "Wilmette Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1241 Central Ave",
      city: "Wilmette",
      state: "IL",
      zip: "60091",
      phone: "(847) 251-2006",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Wilmette, approximately 5 miles east of Glenview",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Wilmette and eastern North Shore communities. Convenient for Glenview residents near the lakefront and eastern neighborhoods. Good alternative with extended hours.",
      icon: "ri-mail-line",
    },
    {
      id: "glv-4",
      name: "Morton Grove Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "9114 Waukegan Rd",
      city: "Morton Grove",
      state: "IL",
      zip: "60053",
      phone: "(847) 966-1095",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Morton Grove, approximately 4 miles south of Glenview",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Morton Grove and southern Glenview residents. Convenient for residents near the Glenview-Morton Grove border. Good alternative with generally shorter wait times.",
      icon: "ri-mail-line",
    },
    {
      id: "glv-5",
      name: "Deerfield Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "707 Osterman Ave",
      city: "Deerfield",
      state: "IL",
      zip: "60015",
      phone: "(847) 945-0426",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Deerfield, approximately 8 miles north of Glenview",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Deerfield and northern North Shore communities. Convenient for residents near Deerfield Road corridor. Good alternative with extended hours.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — downtown Chicago, Loop parking", fpc: "No — ship from The Glen" },
    { feature: "Time Commitment", agency: "2+ hours with traffic and parking", fpc: "Minutes — ship during your lunch break" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Practical for N. Shore", agency: "No — downtown traffic is a time sink", fpc: "Yes — the efficient choice" },
  ],
  mistakes: [
    {
      icon: "ri-calendar-close-line",
      title: "Corporate Travel Rush",
      description: "Glenview's corporate professionals often get last-minute international meeting assignments and discover passport issues days before departure. Even though Chicago is only 35 minutes away, downtown traffic and Loop parking turn it into a 2+ hour ordeal. Our courier service handles it while you prepare for your meetings.",
    },
    {
      icon: "ri-road-map-line",
      title: "Underestimating Downtown Chicago Hassle",
      description: "Glenview is geographically close to the Chicago Passport Agency — just 35 minutes without traffic. But add I-94 congestion, Loop parking ($30+), security lines, and waiting time, and it becomes a 2-3 hour commitment. For North Shore professionals, that's billable time lost.",
    },
    {
      icon: "ri-passport-line",
      title: "Six-Month Validity for Business Travel",
      description: "Frequent North Shore business travelers often don't check the 6-month validity requirement for EU and Asian countries. A passport valid for 4 months won't get you into Germany, Singapore, or China for meetings. Check validity before booking international business flights.",
    },
    {
      icon: "ri-image-line",
      title: "Rushed Passport Photos",
      description: "Glenview professionals rushing to get photos at the last minute often end up with non-compliant photos — wrong background, glasses glare, wrong dimensions. UPS Store at The Glen does them right. A photo rejection adds days to your timeline when you have none to spare.",
    },
    {
      icon: "ri-file-list-line",
      title: "Wrong Renewal Form",
      description: "North Shore residents who renew by mail using DS-82 sometimes don't realize their last passport was issued more than 15 years ago (requiring DS-11 instead) or was issued when they were under 16. These are automatic rejections. Our document review catches these before submission.",
    },
    {
      icon: "ri-global-line",
      title: "Business Visa vs Passport Timing",
      description: "Corporate travelers sometimes confuse business visa requirements with passport validity. Countries like China, India, and Brazil require passport validity well beyond your visa application date. Start the passport renewal process before applying for any business visa — you can't get a visa in a passport that's about to expire.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from your office, home, or anywhere in Glenview." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop at UPS Store at The Glen or any FedEx near your office." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document — experienced with corporate travel, North Shore family needs, and international business requirements." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to the Chicago Passport Agency — 35 minutes away but you never make the downtown trip." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Glenview address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Glenview, IL?", a: "Fast Passport Center offers emergency passport processing in Glenview, Illinois in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (35 minutes south via I-94) — without you dealing with downtown traffic, Loop parking, and security lines." },
    { q: "Do I really need a courier when Chicago is so close to Glenview?", a: "While the Chicago Passport Agency is only 35 minutes from Glenview on a good day, the reality includes I-94 congestion, downtown parking ($30-40), building security, and waiting time — easily 2+ hours. For North Shore professionals, our courier service saves that time entirely. Plus, appointments at the agency are booked weeks out for non-emergencies." },
    { q: "Do you serve corporate travelers in Glenview?", a: "Absolutely. Fast Passport Center serves Glenview's corporate community — including executives at the numerous business parks and corporate headquarters in the area. We understand international business travel, last-minute meeting assignments, and the need for reliable, fast service that doesn't disrupt your work schedule." },
    { q: "What airport do Glenview travelers use?", a: "Glenview is perfectly positioned between Chicago O'Hare International Airport (ORD) — approximately 20 minutes southwest, and Chicago Midway (MDW) — approximately 35 minutes southeast. Both offer extensive international connections. ORD is the preferred airport for most North Shore international travelers." },
    { q: "Can I get my child's passport expedited in Glenview?", a: "Yes. Fast Passport Center expedites child passports in Glenview for minors under 16. Both parents must appear or submit notarized consent. We guide North Shore families through the entire DS-11 process for minors." },
    { q: "Where can I get passport photos in Glenview?", a: "The UPS Store at The Glen Town Center offers passport photos. Walgreens on Waukegan Road, CVS on Milwaukee Avenue, and the Glenview Post Office also provide photo services. Photos must be 2x2 inches on a white background." },
    { q: "Is there a faster option than driving downtown?", a: "Not practically — even though Chicago is geographically close, the appointment wait (weeks), downtown parking, and security procedures make the DIY approach very time-consuming. Fast Passport Center's courier service is the most efficient option for Glenview residents who value their time — especially corporate professionals who can't afford to spend half a day on passport logistics." },
  ],
  photoLocations: [
    { name: "UPS Store — The Glen", address: "2670 Navy Blvd, Glenview, IL 60026", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–3PM", website: "https://www.theupsstore.com/" },
    { name: "Walgreens — Glenview", address: "1400 Waukegan Rd, Glenview, IL 60025", hours: "Mon–Sun: 8AM–10PM", website: "https://www.walgreens.com/" },
    { name: "CVS — Glenview", address: "2502 Waukegan Rd, Glenview, IL 60025", hours: "Mon–Sun: 8AM–9PM", website: "https://www.cvs.com/" },
    { name: "Glenview Post Office", address: "1400 Patriot Blvd, Glenview, IL 60026", hours: "Mon–Fri: 9AM–4:30PM (photo services by appointment)", website: "https://tools.usps.com/find-location.htm" },
  ],
  dmvLocations: [
    { name: "Illinois SOS — Des Plaines", address: "1470 Lee St, Des Plaines, IL 60018", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Illinois Secretary of State for driver's licenses, REAL ID, and vehicle registration. About 10 minutes from Glenview via Golf Road. Online reservations strongly recommended.", featured: true },
    { name: "Illinois SOS — Deerfield", address: "425 Lake Cook Rd, Deerfield, IL 60015", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Serves northern North Shore communities. REAL ID processing available. About 10 minutes north via I-94 — good alternative with generally shorter wait times.", featured: false },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates (IDPH)", url: "https://dph.illinois.gov/topics-services/birth-death-other-records.html", desc: "Illinois Department of Public Health — Division of Vital Records for Cook County birth and death certificates" },
    { label: "Marriage Licenses (Cook County Clerk)", url: "https://www.cookcountyclerk.com/service/marriage-licenses", desc: "Cook County Clerk — marriage license applications and certified copies for Glenview and North Shore" },
    { label: "Divorce Decrees (Cook County Circuit Clerk)", url: "https://www.cookcountyclerkofcourt.org/", desc: "Cook County Circuit Clerk — divorce decree records for Glenview and Cook County residents" },
    { label: "VitalChek Online Ordering", url: "https://www.vitalchek.com/", desc: "Order Illinois birth, death, marriage, and divorce certificates online via VitalChek — fastest state-approved method" },
  ],
  airports: [
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "Approximately 20 minutes southwest via I-294",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "Major international hub and the closest airport to Glenview. Extensive global connections with direct flights worldwide. About 20 minutes from Glenview via the Tri-State Tollway.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "ORD Flight Info",
      featured: true,
    },
    {
      code: "MDW",
      name: "Chicago Midway International Airport",
      distance: "Approximately 35 minutes southeast via I-294/I-55",
      address: "5700 S Cicero Ave, Chicago, IL 60638",
      note: "Southwest Airlines hub with extensive domestic and some international routes. About 35 minutes from Glenview. Good for domestic business travel and some Mexico/Caribbean destinations.",
      flightUrl: "https://www.flychicago.com/midway/",
      flightLabel: "MDW Flight Info",
      featured: false,
    },
  ],
};